import { computed } from 'mobx';
import { CXContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-container-block.model';
import type { CXQuestionBlock } from '~/components/ClientExperience/OneFlow/models/cx-question-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { ILeadDetailsBlockResponse } from '~/types/server.types';

export class CXLeadDetailsBlock extends CXContainerBlock {
    type: 'lead_details_block';

    constructor(
        block: ILeadDetailsBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    @computed
    get questionBlocks() {
        return this.allDescendants().filter(
            (block): block is CXQuestionBlock => block.isQuestionBlock
        );
    }

    @computed
    get emailQuestionBlock() {
        return this.questionBlocks.find(
            block =>
                'validation_type' in block.question &&
                block.question.validation_type === 'email'
        );
    }

    @computed
    get fullNameQuestionBlock() {
        return this.questionBlocks.find(
            block => block.block_id !== this.emailQuestionBlock.block_id
        );
    }

    @computed
    get leadDetailsVariableIds() {
        return {
            leadInfoEmailVarId: this.emailQuestionBlock.connected_variable_id,
            leadInfoFullNameVarId:
                this.fullNameQuestionBlock.connected_variable_id
        };
    }
}
